<template>
    <div class="custom_wrapper">

        <transition name="fade">
            <chrome v-if="isColorPickerActive" class="color_picker" :value="color"
                    @input="updateValueFromColorPicker"
                    :style="{ top: this.colorPickerY+'px', left: this.colorPickerX+'px'}"/>
        </transition>

        <div class="graph_parts_collapse-container" :class="{open : isOpen, close: !isOpen}"
             :style="{ maxHeight: elementsContainerHeight + 'px'}">
            <div @click="toggleOpen" class="title-container" ref="title_container">
                <h2 class="title">{{translate(getPartsOfTheGraph.title)}}</h2>
                <div class="plus_icon"></div>
            </div>

            <div class="content-wrapper" ref="elements_container">


                <div class="parts_of_params-container">

                    <ul v-for="(param, param_key) in getPartsOfTheGraph.mainAxisParams"
                        class="parts-column">
                        <li v-for="(specificPart, specific_part_key) in param.specificParts"
                            :style='{ background: (specificPart.active && printAditionalInfo(param_key, specific_part_key) != " (-)") ? specificPart.color : "", border: (specificPart.active && printAditionalInfo(param_key, specific_part_key) == " (-)") ? "1px dashed " + specificPart.color : ""}'
                            @click="!param.locked ? togglePartOfParam(param_key, specific_part_key, !specificPart.active) : ''"
                            @contextmenu.stop.prevent="openColorPicker($event, param_key, specific_part_key)"
                            class="part" :class="{'disabled': isParamDisabled(specific_part_key)}">
                        <span class="title"
                              v-html="translate(specificPart.title) + printAditionalInfo(param_key, specific_part_key)"
                              :class='{black_fonted : specificPart.active && printAditionalInfo(param_key, specific_part_key) != " (-)" && !param.locked}'/>
                        </li>
                    </ul>
                </div>

                <h2 class="main_axis_params-title">{{translate("main_axis")}}</h2>
                <ul class="main_axis_params-container">
                    <li v-for="(param, key) in getPartsOfTheGraph.mainAxisParams"
                        :style="{background: isAnyPartOfMainAxisParamActive(key) ? param.color : ''}"
                        @click="!param.locked ? selectMainAxisParam(key) : ''"
                        @contextmenu.stop.prevent="openColorPicker($event, key)"
                        class="param"
                        :class="{part_is_active : isAnyPartOfMainAxisParamActive(key)}">
                        <div class="icon-container"
                             :class="{extended : param.active}">
                            <span class="icon-ok"/>
                        </div>
                        <span class="title" v-html="translate(param.title)"/>
                    </li>
                </ul>
            </div>
        </div>
    </div>


</template>

<script>
    export default {
        name: "GraphPartsCollapse",
        data() {
            return {
                isOpen: true,
                elementsContainerHeight: 0,
                defaultMaxHeight: 43,
                color: '',
                isColorPickerActive: false,
                paramIdForColorPicker: '',
                specificPartIdForColorPicker: '',
                colorPickerX: '',
                colorPickerY: ''
            }
        },
        props: ['offerView'],
        methods: {
            printAditionalInfo(paramKey, specific_part_key) {
                if (paramKey == "current") {
                    let voltages = this.getActiveFunVoltages();
                    if (specific_part_key == "Amperage" && voltages[0])
                        return " (" + voltages[0] + "&nbsp;V)";
                    else if (specific_part_key == "AmperageV2" && voltages[1])
                        return " (" + voltages[1] + "&nbsp;V)";

                    return " (-)";
                }

                return "";
            },

            isParamDisabled(paramKey) {
                let disabled = false;

                if (paramKey === 'PowerOnShaftWithMaterial') {
                    let activeFan = this.$store.state.activeFun;
                    if (activeFan.params.hasOwnProperty('power_on_shaft_with_material')) {
                        disabled = activeFan.params.power_on_shaft_with_material === activeFan.params.power_on_shaft;
                    } else {
                        disabled = true;
                    }
                }

                // NVS-131 - wyszarzenie kafelka gdy w pomiarze wybrano 'bez obudowy'
                if (paramKey === 'StaticPressureIncrease' && this.$store.state.activeFun && this.$store.state.activeFun.data && parseInt(this.$store.state.activeFun.data.no_housing) === 1) disabled = true;

                return disabled;
            },

            translate(code) {
                let arg = {
                    type: 'translate',
                    code: code,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;

            },
            updateValueFromColorPicker(e) {
                let rgba_color = 'rgba(' + e.rgba.r + ',' + e.rgba.g + ',' + e.rgba.b + ',' + e.rgba.a + ')';

                if (this.specificPartIdForColorPicker !== '') {

                    this.$store.commit({
                        type: 'updateColorPartOfMainAxisParam',
                        param_id: this.paramIdForColorPicker,
                        specific_part_id: this.specificPartIdForColorPicker,
                        color: rgba_color
                    });

                } else {

                    this.$store.commit({
                        type: 'updateColorOfMainAxisParam',
                        param_id: this.paramIdForColorPicker,
                        color: rgba_color
                    });
                }
            },

            openColorPicker(event, param_id, specific_part_id) {

                this.colorPickerX = event.clientX;
                this.colorPickerY = event.clientY - 100;
                this.isColorPickerActive = true;
                this.paramIdForColorPicker = param_id;

                specific_part_id ? this.specificPartIdForColorPicker = specific_part_id : '';
            },

            closeOnWindowClick(e) {

                let target = e.target;

                while (target instanceof Element) {

                    if (target.classList.contains('color_picker')) {
                        return;
                    }

                    target = target.parentNode;
                }

                this.paramIdForColorPicker = '';
                this.specificPartIdForColorPicker = '';
                this.isColorPickerActive = false;
            },

            selectMainAxisParam(param_id) {

                if (this.isAnyPartOfMainAxisParamActive(param_id)) {

                    this.clearMainAxisParams();

                    this.$store.commit({
                        type: 'selectMainAxisParam',
                        param_id: param_id
                    });
                }
            },

            clearMainAxisParams() {

                this.$store.commit({
                    type: 'clearMainAxisParams'
                });
            },

            togglePartOfParam(param_id, specific_part_id, isActive) {

                this.$store.commit({
                    type: 'togglePartOfMainAxisParam',
                    param_id: param_id,
                    specific_part_id: specific_part_id,
                    isActive: isActive
                });


                if (!this.isActiveParamWithActiveParamPart()) {

                    this.findFirstAvailableParam();
                }
            },

            isActiveParamWithActiveParamPart() {

                let isActiveParamWithActiveParamPart = false;
                let mainAxisParams = this.getPartsOfTheGraph.mainAxisParams;
                let _this = this;

                Object.keys(mainAxisParams).forEach(function (param_id) {

                    if (mainAxisParams[param_id].active && _this.isAnyPartOfMainAxisParamActive(param_id)) {

                        isActiveParamWithActiveParamPart = true;
                        return false;
                    }
                });

                return isActiveParamWithActiveParamPart;
            },

            isAnyPartOfMainAxisParamActive(param_id) {

                let isAnyPartOfMainAxisParamActive = false;
                let partsOfMainAxisParam = this.getPartsOfTheGraph.mainAxisParams[param_id].specificParts;

                Object.keys(partsOfMainAxisParam).forEach(function (specific_part_id) {

                    if (partsOfMainAxisParam[specific_part_id].active) {

                        isAnyPartOfMainAxisParamActive = true;
                        return false;
                    }
                });

                return isAnyPartOfMainAxisParamActive;
            },

            findFirstAvailableParam() {
                let mainAxisParams = this.getPartsOfTheGraph.mainAxisParams;
                let _this = this;

                Object.keys(mainAxisParams).forEach(function (param_id) {

                    if (param_id != "performance" && _this.isAnyPartOfMainAxisParamActive(param_id) && !_this.isActiveParamWithActiveParamPart()) {

                        _this.selectMainAxisParam(param_id);
                    }
                });
            },

            addListener() {
                let _this = this;
                window.addEventListener('resize', _this.setMaxHeight)
            },

            removeListener() {
                let _this = this;
                window.removeEventListener('resize', _this.setMaxHeight);
            },

            toggleOpen() {
                this.isOpen = !this.isOpen;
                this.setMaxHeight();
            },

            setMaxHeight() {
                if (this.isOpen && this.$refs.elements_container.clientHeight && this.$refs.title_container.clientHeight && !this.offerView) {
                    this.elementsContainerHeight = this.$refs.elements_container.clientHeight + this.$refs.title_container.clientHeight;

                } else {
                    this.elementsContainerHeight = this.defaultMaxHeight;
                }
            },
            getActiveFunVoltages() {
                if (this.$store.state.activeFun && this.$store.state.activeFun.data && this.$store.state.activeFun.data.network_frequency && this.$store.state.activeFun.engine) {
                    let frequency = this.GetSelectedElementOfOption(this.$store.state.fourthStepParametersSelected.network_frequency.options[0].elements);

                    let voltage = this.$store.state.activeFun.engine['voltage_' + frequency + '_hz'];

                    if (voltage) {
                        let voltages = voltage.split("/");

                        return voltages;
                    }
                }

                return [];
            },

            GetSelectedElementOfOption(elements) {
                for (let elementId in elements) {
                    if (elements.hasOwnProperty(elementId) && elements[elementId].active == true)
                        return elements[elementId].value;
                }

                return null;
            },

        },
        computed: {

            getPartsOfTheGraph() {
                return this.$store.state.partsOfTheGraph;
            }
        },

        mounted() {
            this.addListener();
            this.setMaxHeight();
            window.addEventListener('click', this.closeOnWindowClick.bind(this));

        },

        beforeDestroy() {
            this.removeListener();
            window.removeEventListener('click', this.closeOnWindowClick.bind(this));

        }
    }
</script>

<style scoped lang="scss">
    .fade-enter, .fade-leave-to {
        opacity: 0;
        padding-bottom: 0;
    }
</style>
